import { useState } from "react"
import { useNavigate } from "react-router"
import { Formik } from "formik"
import * as Yup from "yup"

import { genericErrMsg } from "../../../api/auth"
import { useBirddogSignup } from "../hooks/useBirddogSignup"
import BirddogSignupFormComponent from "./BirddogSignupFormComponent"
import { BirddogSignupDataTypes } from "../types/auth"

const validationSchema = Yup.object().shape({
  first_name: Yup.string().required("Please provide your first name."),
  last_name: Yup.string().required("Please provide your last name."),
  email: Yup.string()
    .email("Please provide a valid email address.")
    .required("Please provide your email address."),
  password: Yup.string()
    .required("Please provide a password.")
    .min(8, "Password must be at least 8 characters."),
  company_name: Yup.string().required("Please provide your company name."),
  role: Yup.string()
    .oneOf(["forester", "timber_buyer"], "Please select a role.")
    .required("Please select a role."),
})

const BirddogSignupForm = () => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null)
  const navigate = useNavigate()

  const { mutateAsync: birddogSignup } = useBirddogSignup({
    onSuccess: () => {
      // Redirect directly to BirdDog dashboard, skip email verification
      navigate("/birddog/dashboard")
    },
    onError: (error: { detail: string }) => {
      setErrorMessage(error?.detail || genericErrMsg)
    },
  })

  const onSubmit = async (values: BirddogSignupDataTypes) => {
    await birddogSignup(values)
  }

  return (
    <Formik
      initialValues={{
        first_name: "",
        last_name: "",
        email: "",
        password: "",
        company_name: "",
        role: "" as "forester" | "timber_buyer",
      }}
      validationSchema={validationSchema}
      validateOnBlur={false}
      validateOnChange={false}
      onSubmit={onSubmit}
    >
      {(formikProps) => (
        <BirddogSignupFormComponent
          {...formikProps}
          errorMessage={errorMessage}
        />
      )}
    </Formik>
  )
}

export default BirddogSignupForm
